/** Vector Marine mobile app listings — single source for every "download the app" surface. */
export const IOS_STORE_URL = 'https://apps.apple.com/us/app/vector-marine/id6757459006';
export const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=com.vectormarine.app';
